import { withVersions } from "v2/hocs/withVersions";
import withTradeRowItem from "../hocs/withTradeRowItem";
import TradeRowItemV1 from "./TradeRowItem/v1";
import TradeRowItemV2 from "./TradeRowItem/v2";
import TradeRowItemWithMentioned from "./TradeRowItem/withMentioned";

const TradeRowItem = withVersions({
  v1: withTradeRowItem(TradeRowItemV1),
  v2: withTradeRowItem(TradeRowItemV2),
  withMentioned: withTradeRowItem(TradeRowItemWithMentioned),
});

export default TradeRowItem;
